import { queryFetch } from '../api';
import { SignInResp } from './types';

const REDEEM_TIMEOUT_MS = 10 * 1000;

interface SignInExchangeResp {
  success: boolean;
  data: { code: string };
}

export const createSignInExchange = () =>
  queryFetch<SignInExchangeResp>({
    url: 'sign_in_exchanges',
    opt: { method: 'POST' },
  });

export const redeemSignInExchange = (code: string) =>
  queryFetch<SignInResp>({
    url: `sign_in_exchanges/${code}/redeem`,
    opt: { method: 'POST' },
    auth: false,
    timeout: REDEEM_TIMEOUT_MS,
  });
